import React, { useState } from "react";
import { Menu, PageHeader } from "@pushpress/shared-components";
import PageContainer from "../../../components/common/PageContainer/PageContainer";
import { useToggle } from "../../../hooks/state";
import PayRatesTable from "./PayRatesTable";
import PayRatesDrawer from "./PayRatesDrawer";
import {
  StaffRowFragment,
  useGetStaffQuery,
} from "./AppointmentPayRateList-generated.hooks";
import { Card } from "@pushpress/pushpress-ui";
import { Percent } from "lucide-react";

function AppointmentPayRateList() {
  const [editVisible, editActions] = useToggle(false);
  const [selectedStaff, setSelectedStaff] = useState<StaffRowFragment>();

  const { loading, data, refetch } = useGetStaffQuery({
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  const renderRowMenu = (row: StaffRowFragment, closeMenu: VoidFunction) => {
    return (
      <Menu>
        <Menu.Item
          key="edit"
          label="Edit"
          action={() => {
            setSelectedStaff(row);
            editActions.on();
            closeMenu();
          }}
        />
      </Menu>
    );
  };

  const handleSuccess = () => {
    refetch();
    editActions.off();
  };

  return (
    <>
      <div className="tw-flex tw-flex-col md:tw-px-8 md:tw-pt-4 tw-w-full tw-mx-auto tw-max-w-7xl">
        <PageContainer>
          <PageHeader title="Pay rates" />
          <div className="tw-mb-4">
            <Card className="tw-p-4">
              <div className="tw-flex tw-items-center tw-gap-4">
                <div className="tw-rounded-full tw-bg-blue-50 tw-border tw-border-blue-100 tw-p-2">
                  <Percent className="tw-w-8 tw-h-8 tw-text-gray-600" />
                </div>
                <div>
                  <p className="tw-text-sm tw-text-gray-600 tw-mb-1">
                    Configure how your staff gets paid for classes,
                    appointments, and client assignments. Set custom rates using
                    flat fees or percentage-based payments for each staff
                    member.
                  </p>
                  <p className="tw-text-sm tw-text-gray-500">
                    👋 Need help? Check out our detailed{" "}
                    <a
                      href="https://help.pushpress.com/en/articles/1176188-core-setting-up-staff-pay-rates"
                      target="_blank"
                      rel="noreferrer"
                    >
                      setup guide.
                    </a>
                  </p>
                </div>
              </div>
            </Card>
          </div>
          <PayRatesTable
            data={data?.getStaff}
            loading={loading}
            renderRowMenu={renderRowMenu}
          />
        </PageContainer>
        <PayRatesDrawer
          visible={editVisible}
          staff={selectedStaff}
          onClose={editActions.off}
          onSuccess={handleSuccess}
        />
      </div>
    </>
  );
}

export default AppointmentPayRateList;
